import { PayloadAction } from '../../../store.model';
import { ActionType } from '../form.action';
import { FormState } from '../form.state';

import {
    HidePublishConfirmDialog,
    ShowPublishConfirmDialog,
} from './dialog.action';

export function showPublishConfirmDialogReducer(
    state: FormState,
    _: PayloadAction<
        ActionType.EVAL_FORM__SHOW_PUBLISH_CONFIRM_DIALOG,
        ShowPublishConfirmDialog
    >,
): FormState {
    return {
        ...state,
        pending: {
            ...state.pending,
            showPublishConfirmDialog: true,
        },
    };
}

export function hidePublishConfirmDialogReducer(
    state: FormState,
    _: PayloadAction<
        ActionType.EVAL_FORM__HIDE_PUBLISH_CONFIRM_DIALOG,
        HidePublishConfirmDialog
    >,
): FormState {
    return {
        ...state,
        pending: {
            ...state.pending,
            showPublishConfirmDialog: false,
        },
    };
}
